import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

interface ErrorDialogProps {
    open: boolean;
    errorMessage: string;
    onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, errorMessage, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="error-dialog-title" aria-describedby="error-dialog-description">
            <DialogTitle id="error-dialog-title">エラー</DialogTitle>
            <DialogContent>
                <DialogContentText id="error-dialog-description">
                    {errorMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" data-testid="close-button">閉じる</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorDialog;
